export default __webpack_public_path__ + "static/media/T500MANA2.1d583bcb.pdf";